import { defineComponent, computed, unref } from "vue";
import { p as pick } from "../../../vendor-2b2dbafd.mjs";
import { u as useFloatingPositionProps, a as useFloatingPosition } from "./hooks/useFloatingPositionStyles-606746f8.mjs";
import { u as useDeprecated } from "../../composables/useDeprecated-76095652.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useBem } from "../../composables/useBem-33d80128.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
import { u as useTextColor } from "../../composables/useTextColor-d6b2d8c3.mjs";
const _sfc_main = defineComponent({
  name: "VaBadge",
  props: {
    ...useComponentPresetProp,
    ...useFloatingPositionProps,
    color: { type: String, default: "danger" },
    textColor: { type: String },
    text: { type: [String, Number], default: "" },
    multiLine: { type: Boolean, default: false },
    visibleEmpty: { type: Boolean, default: false },
    dot: { type: Boolean, default: false },
    // TODO: Remove after 1.8.0
    transparent: { type: Boolean, default: false }
  },
  setup(props, { slots }) {
    useDeprecated(["transparent"]);
    const isEmpty = computed(() => !(props.text || props.visibleEmpty || props.dot || slots.text));
    const isFloating = computed(() => !!(slots.default || props.dot));
    const badgeClass = useBem("va-badge", () => ({
      ...pick(props, ["visibleEmpty", "dot", "multiLine"]),
      empty: isEmpty.value,
      floating: isFloating.value
    }));
    const { getColor } = useColors();
    const { textColorComputed } = useTextColor();
    const colorComputed = computed(() => getColor(props.color));
    const positionStylesComputed = useFloatingPosition(props, isFloating);
    const stylesComputed = computed(() => ({
      color: textColorComputed.value,
      borderColor: colorComputed.value,
      backgroundColor: colorComputed.value,
      opacity: props.transparent ? 0.5 : 1,
      ...unref(positionStylesComputed)
    }));
    const ariaLabelledByComputed = computed(() => props.text ? String(props.text) : void 0);
    return {
      badgeClass,
      stylesComputed,
      ariaLabelledByComputed
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaBadge.css';
//# sourceMappingURL=VaBadge.vue_vue_type_script_lang-350e1887.mjs.map
